import React, { useState, useEffect } from 'react';

export default function MissionAndTestimonials() {
  const testimonials = [
    {
      stars: 5,
      quote: "Haritika explains investing like a patient teacher, not an influencer. My SIPs finally have a plan behind them.",
      initial: "R",
      name: "Rahul Verma",
      role: "Software Engineer, Pune"
    },
    {
      stars: 5,
      quote: "Welvate I finally understand why I enter a trade — and when to stay out.",
      initial: "A",
      name: "Arjun Mehta",
      role: "Product Manager, Bengaluru"
    },
    {
      stars: 5,
      quote: "The practical approach to mutual funds and risk management completely changed how I look at my family's savings.",
      initial: "P",
      name: "Priya Sharma",
      role: "Chartered Accountant, Delhi"
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-play slider effect (changes slide every 4 seconds)
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
    }, 4000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="space-y-10 py-6 max-w-7xl mx-auto px-6 font-sans">
      
      {/* 1. Mission & Vision Section */}
      <section className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Our Mission Card */}
          <div className="bg-white rounded-2xl p-6 border border-gray-200/80 shadow-sm space-y-3">
            <span className="text-xs font-bold tracking-widest text-[#16325B] uppercase block">
              OUR MISSION
            </span>
            <p className="font-serif-title text-base sm:text-lg font-bold text-[#0A2540] leading-relaxed">
              Simplify finance, empower people through practical education, and deliver ethical, research-driven solutions — with a special commitment to helping women become confident, financially independent investors.
            </p>
          </div>

          {/* Our Vision Card */}
          <div className="bg-white rounded-2xl p-6 border border-gray-200/80 shadow-sm space-y-3">
            <span className="text-xs font-bold tracking-widest text-[#D97706] uppercase block">
              OUR VISION
            </span>
            <p className="font-serif-title text-base sm:text-lg font-bold text-[#0A2540] leading-relaxed">
              To become one of India's most trusted financial brands — making quality guidance accessible to everyone and inspiring a generation of informed investors.
            </p>
          </div>
        </div>

        {/* Bottom Tagline Banner */}
        <div className="bg-[#FAF8F5] border border-dashed border-gray-300 rounded-2xl p-3.5 text-center">
          <p className="font-serif-title text-sm sm:text-base font-bold text-[#0A2540]">
            Elevating Wealth. <span className="text-[#16325B]">Empowering Futures.</span> <span className="text-[#D97706]">Inspiring Financial Independence.</span>
          </p>
        </div>
      </section>

      {/* 2. Student Testimonials Auto-Slider Section */}
      <section className="space-y-6 pt-2">
        <div className="text-center">
          <h2 className="font-serif-title text-3xl sm:text-4xl font-bold text-[#0A2540]">
            From students who <span className="italic text-[#16325B] font-normal">did the work</span>
          </h2>
        </div>

        {/* Testimonial Card */}
        <div className="max-w-3xl mx-auto">
          <div className="bg-[#FAF7F2] border border-gray-200/70 rounded-3xl p-6 sm:p-8 shadow-sm relative space-y-4">
            
            {/* Top Row: Stars & Nav Arrows */}
            <div className="flex justify-between items-center">
              <div className="flex text-[#D97706] text-sm tracking-wider">
                {"★".repeat(testimonials[currentIndex].stars)}
              </div>

              <div className="flex gap-2">
                <button 
                  onClick={handlePrev} 
                  className="w-8 h-8 rounded-full bg-white border border-gray-200 hover:border-gray-400 flex items-center justify-center text-xs font-bold text-gray-700 transition"
                >
                  ←
                </button>
                <button 
                  onClick={handleNext} 
                  className="w-8 h-8 rounded-full bg-white border border-gray-200 hover:border-gray-400 flex items-center justify-center text-xs font-bold text-gray-700 transition"
                >
                  →
                </button>
              </div>
            </div>

            {/* Quote Text */}
            <p className="font-serif-title text-base sm:text-lg font-medium text-gray-800 leading-relaxed italic min-h-[60px]">
              "{testimonials[currentIndex].quote}"
            </p>

            {/* User Info */}
            <div className="flex items-center gap-3 pt-1">
              <div className="w-9 h-9 rounded-full bg-[#16325B] text-white flex items-center justify-center font-bold text-xs shrink-0">
                {testimonials[currentIndex].initial}
              </div>
              <div>
                <h4 className="font-bold text-sm text-gray-900 leading-tight">
                  {testimonials[currentIndex].name}
                </h4>
                <p className="text-xs text-gray-500">
                  {testimonials[currentIndex].role}
                </p>
              </div>
            </div>

          </div>

          {/* Pagination Dots */}
          <div className="flex justify-center gap-2 mt-4">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                className={`h-2 rounded-full transition-all duration-300 ${
                  currentIndex === idx ? 'w-6 bg-[#16325B]' : 'w-2 bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}